
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'HFMUSICRISKSCORE',
components: {
XTable
},
data () {
return {
form: {
data1: '0',
data2: '0',
data3: '0',
data4: '0',
data5: '0',
data6: '0',
data7: '0',
data8: '0',
data9: '0',
data10: '0'
},
score1: '0',
score2: '0',
score3: '0',
descTxt: ''
}
},
computed: {
score () {
let self = this
let form = JSON.parse(JSON.stringify(self.form))
for (const key in form) {
if (form.hasOwnProperty(key)) {
if (form[key] !== '0') {
form[key] = 1
} else {
form[key] = 0
}
}
}
let result = 0
let result1 = 0
let result2 = 0
let result3 = 0
console.log(form, 444)
if (form.data1) {
result += 3
result1 += 3
result2 += 0
result3 += 8
}
if (form.data2) {
result += 8
result1 += 9
result2 += 9
result3 += 11
}
if (form.data3) {
result += 5
result1 += 5
result2 += 5
result3 += 0
}
if (form.data4) {
result += 3
}
if (form.data5) {
result3 += 7
}

if (form.data6) {
result += 3
result1 += 4
result2 += 0
result3 += 7
}

if (form.data7) {
result += 4
result1 += 4
result2 += 5
result3 += 0
}

if (form.data8) {
result += 3
result1 += 3
result2 += 4
result3 += 0
}

if (form.data9) {
result += 7
result1 += 7
result2 += 10
result3 += 7
}
if (form.data10) {
result += 4
result1 += 5
result2 += 7
result3 += 0
}
self.score1 = result1.toString()
self.score2 = result2.toString()
self.score3 = result3.toString()
console.log(result, 22)
if (result > 20 || result1 > 20 || result2 > 20 || result3 > 20) {
self.descTxt = '高危'
}
return result.toString()
}
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/HFMUSICRISKSCORE.vue